<common-confirm></common-confirm>

<h1 class="container-heading">{{ action | ucfirst }} service map</h1>

<mat-card>
    <mat-card-content>

        <form *ngIf="formGroup" [formGroup]="formGroup" (submit)="handleFormSubmit()" autocomplete="off"
              novalidate>

            <div class="group flex">

                <common-form-hub-select
                        label="Hub from"
                        class="full"
                        [required]="true"
                        [multiple]="action==='add'"
                        [value]="action==='add' ? [] : formGroup.value.outbound_hub_id"
                        empty_list_message="Hubs not found"
                        (onChange)="onHubSelected($event)"></common-form-hub-select>


                <common-form-select *ngIf="countries.length"
                                    [options]="countries"
                                    label="Destination country"
                                    class="full"
                                    (onClose)="onCountrySelected($event)"
                                    [required]="true"
                                    [multiple]="action==='add'"
                                    [search]="true"
                                    [image]="{path:'assets/images/flags',ext:'svg'}"
                                    [value]="action==='add' ? [] : formGroup.value.destination_country_iso_2"></common-form-select>

                <common-form-search class="full"
                                    label="Customer"
                                    [value]="formGroup.value.customer_id"
                                    [initShowValue]="data?.customer?.name"
                                    url="/customers?only_active=true&search_in[0]=name"
                                    [apiVersion]="3"
                                    (valueChange)="formGroup.get('customer_id').setValue($event)"
                ></common-form-search>

                <common-form-select class="full"
                                    label="Courier"
                                    [required]="true"
                                    [search]="true"
                                    [caseSensitiveSearch]="false"
                                    [options]="couriers"
                                    [value]="formGroup.value.courier_id"
                                    (onClose)="formGroup.get('courier_id').setValue($event)"
                ></common-form-select>

                <common-form-select class="full" *ngIf="courierServices.length"
                                    label="Courier Service"
                                    [required]="true"
                                    [search]="true"
                                    [caseSensitiveSearch]="false"
                                    [options]="courierServices"
                                    [value]="formGroup.value.courier_service_id"
                                    (valueChange)="formGroup.get('courier_service_id').setValue($event)"
                ></common-form-select>

                <mat-form-field class="full" *ngIf="servicesList">
                    <mat-label>Service account</mat-label>
                    <mat-select formControlName="shippy_pro_carrier_id" required>

                        <mat-option *ngFor="let group of servicesList" [value]="group.carrier_id">
                            <img height="36" class="margin-right-10 vertical-middle" [src]="group.logo" alt="">
                            {{ group.name }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>


            <div class="actions">
                <button mat-raised-button color="primary" type="submit" class="main"
                        [disabled]="!formGroup.valid">
                    Save
                </button>
                <button mat-raised-button *ngIf="modal.params.data"
                        type="button" color="warn" (click)="delete()">
                    Delete
                </button>
                <button mat-button type="button" (click)="showList()">Cancel</button>
            </div>

        </form>

    </mat-card-content>
</mat-card>
